module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//12.jpg?82896865f4e1e782d31644903bd03ef1";